import { apiJsonHeaders, withApiLocale } from "../utils/apiLocale";

const BASE_URL = "/api/users";

export const useUsersQuery = async () => {
  const res = await fetch(`${BASE_URL}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });
  if (!res.ok) {
    throw new Error("Error en la petición");
  }
  return res.json();
};

export const useUserByIdQuery = async (inviteId) => {
  const res = await fetch(`${BASE_URL}/${inviteId}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });
  if (!res.ok) {
    throw new Error("Error en la petición");
  }
  return res.json();
};

export const useLoginUserMutation = async (body) => {
  const res = await fetch(`${BASE_URL}/login`, {
    method: "POST",
    headers: apiJsonHeaders(),
    body: JSON.stringify(withApiLocale(body)),
  });
  if (!res.ok) {
    throw new Error("Error en la petición");
  }
  return res.json();
};

export const useCreateUserMutation = async (body) => {
  const res = await fetch(`${BASE_URL}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
  });
  if (!res.ok) {
    throw new Error("Error en la petición");
  }
  return res.json();
};

export const useUpdateUserMutation = async (id, body) => {
  console.log("body", body);
  const res = await fetch(`${BASE_URL}/${id}`, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
  });
  if (!res.ok) {
    throw new Error("Error en la petición");
  }
  return res.json();
};

export const useDeleteUserMutation = async (id) => {
  const res = await fetch(`${BASE_URL}/${id}`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
    },
  });
  if (!res.ok) {
    throw new Error("Error en la petición");
  }
  return res.json();
};

export const useUsersByUsernameQuery = async (search) => {
  const res = await fetch(
    `${BASE_URL}/username/${encodeURIComponent(search)}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  if (!res.ok) {
    throw new Error("Error en la petición");
  }

  return res.json();
};

export const useUsersByEmailQuery = async (search) => {
  const res = await fetch(`${BASE_URL}/email/${encodeURIComponent(search)}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });
  if (!res.ok) {
    throw new Error("Error en la petición");
  }

  return res.json();
};

export const useRegisterUserMutation = async (body) => {
  const res = await fetch(`${BASE_URL}/register`, {
    method: "POST",
    headers: apiJsonHeaders(),
    body: JSON.stringify(withApiLocale(body)),
  });
  if (!res.ok) {
    throw new Error("Error en la petición");
  }
  return res.json();
};

export const useUserForgotPasswordMutation = async (body) => {
  const res = await fetch(`${BASE_URL}/forgot-password`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
  });
  if (!res.ok) {
    throw new Error("Error en la petición");
  }
  return res.json();
};

export const useMedicalHistoryQuery = async (userId) => {
  const res = await fetch(`${BASE_URL}/medical-history/${userId}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });
  if (!res.ok) {
    throw new Error("Error en la petición");
  }
  return res.json();
};

export function usePatient(patientId) {
  return useQuery({
    queryKey: ["patient", patientId],
    queryFn: async () => {
      if (!patientId) return null;

      const { data, error } = await supabase
        .from("profiles")
        .select("*")
        .eq("id", patientId)
        .single();

      if (error) {
        console.error("Error fetching patient:", error);
        throw new Error(error.message);
      }

      return data;
    },
    enabled: !!patientId,
    staleTime: 5 * 60 * 1000, // 5 minutos
    cacheTime: 10 * 60 * 1000, // 10 minutos
  });
}

export const fetchDoctorSecretaries = async (doctorId) => {
  const res = await fetch(`${BASE_URL}/${doctorId}/secretaries`, {
    method: "GET",
    headers: apiJsonHeaders(),
  });

  if (!res.ok) {
    throw new Error("Error al obtener secretarias");
  }

  return res.json();
};

export const createDoctorSecretary = async (doctorId, body) => {
  const res = await fetch(`${BASE_URL}/${doctorId}/secretaries`, {
    method: "POST",
    headers: apiJsonHeaders(),
    body: JSON.stringify(withApiLocale(body)),
  });

  if (!res.ok) {
    const error = await res.json().catch(() => ({}));
    throw new Error(error?.error || "Error al agregar secretaria");
  }

  return res.json();
};

export const removeDoctorSecretary = async (doctorId, secretaryId) => {
  const res = await fetch(
    `${BASE_URL}/${doctorId}/secretaries/${secretaryId}`,
    {
      method: "DELETE",
      headers: apiJsonHeaders(),
    }
  );

  if (!res.ok) {
    const error = await res.json().catch(() => ({}));
    throw new Error(error?.error || "Error al eliminar secretaria");
  }

  return res.json();
};

// Suscripciones
const SUBSCRIPTION_BASE_URL = "/api/mercadopago";

export const createSubscription = async (body) => {
  const res = await fetch(`${SUBSCRIPTION_BASE_URL}/subscription`, {
    method: "POST",
    headers: apiJsonHeaders(),
    body: JSON.stringify(withApiLocale(body)),
  });

  if (!res.ok) {
    const error = await res.json().catch(() => ({}));
    throw new Error(error?.error || "Error al crear la suscripción");
  }

  return res.json();
};

export const getUserSubscription = async (userId) => {
  const res = await fetch(`${SUBSCRIPTION_BASE_URL}/subscription/${userId}`, {
    method: "GET",
    headers: apiJsonHeaders(),
  });

  if (!res.ok) {
    const error = await res.json().catch(() => ({}));
    throw new Error(error?.error || "Error al obtener la suscripción");
  }

  return res.json();
};
